import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-supervisor-voice-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSupervisorVoiceIconProps extends SvgIconProps {
  fillcolor?: string;
}

/**
 *
 * @param props - CcfSupervisorVoiceIconProps
 * @example <CcfSupervisorVoiceIcon />
 * @returns
 */
export function CcfSupervisorVoiceIcon(props: CcfSupervisorVoiceIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M10.32 3.6C10.2 1.62 8.46 0 6.42 0H5.76C3.72 0 2.04 1.62 1.92 3.6C1.92 3.6 1.86 3.6 1.8 3.6C0.84 3.6 0 4.38 0 5.4V7.2C0 8.16 0.84 9 1.8 9C2.76 9 3.6 8.22 3.6 7.2V5.4C3.6 4.92 3.6 4.44 3 4.14V3.84C3 2.4 4.32 1.2 5.76 1.2H6.48C7.92 1.2 9 2.4 9 3.84V3.9C8.4 4.26 8.4 4.8 8.4 5.4V7.2C8.4 7.86 8.76 8.4 9.24 8.76C8.88 9.12 8.22 9.54 7.26 9.78C7.02 9.54 6.66 9.36 6.3 9.36C5.58 9.36 4.98 9.96 4.98 10.68C4.98 11.4 5.58 12 6.3 12C6.96 12 7.5 11.52 7.62 10.92C9.66 10.44 10.56 9.06 10.68 8.94C11.4 8.7 12 8.04 12 7.2V5.4C12 4.44 11.28 3.66 10.32 3.6ZM2.4 7.2C2.4 7.5 2.1 7.8 1.8 7.8C1.5 7.8 1.2 7.5 1.2 7.2V5.4C1.2 5.1 1.5 4.8 1.8 4.8C2.1 4.8 2.4 5.1 2.4 5.4V7.2ZM10.8 7.2C10.8 7.5 10.5 7.8 10.2 7.8C9.9 7.8 9.6 7.5 9.6 7.2V5.4C9.6 5.1 9.9 4.8 10.2 4.8C10.5 4.8 10.8 5.1 10.8 5.4V7.2Z"
        fill="#526B7A"
      />
    </SvgIcon>
  );
}

export default CcfSupervisorVoiceIcon;
